import { motion } from 'motion/react';
import { cn } from '../lib/cn.ts';

export type OrbState = 'idle' | 'connecting' | 'listening' | 'speaking' | 'working' | 'ended' | 'error';

const HUES: Record<OrbState, string> = {
  idle: 'from-sky-400/70 via-indigo-400/60 to-fuchsia-400/60',
  connecting: 'from-sky-400/60 via-indigo-400/50 to-violet-400/50',
  listening: 'from-emerald-300/70 via-sky-400/60 to-indigo-400/60',
  speaking: 'from-amber-300/80 via-rose-400/60 to-fuchsia-500/60',
  working: 'from-violet-300/70 via-indigo-400/60 to-sky-400/60',
  ended: 'from-fg/20 via-fg/10 to-fg/5',
  error: 'from-rose-500/70 via-rose-400/50 to-orange-400/50',
};

export const ORB_STATES = Object.keys(HUES) as OrbState[];

export function Orb({ state, size = 'lg' }: { state: OrbState; size?: 'sm' | 'lg' }) {
  const pulse = state === 'speaking' ? [1, 1.08, 0.98, 1.05, 1] : state === 'listening' ? [1, 1.03, 1] : [1, 1.015, 1];
  return (
    <motion.div
      data-testid="orb"
      data-state={state}
      // Decorative for assistive tech: the status line under it says the same thing in words.
      aria-hidden
      className={cn('relative', size === 'lg' ? 'size-28' : 'size-10')}
      animate={{ scale: pulse }}
      transition={{ duration: state === 'speaking' ? 1.2 : 3, repeat: Number.POSITIVE_INFINITY, ease: 'easeInOut' }}
    >
      <div className={cn('absolute inset-0 rounded-full bg-gradient-to-br blur-xl opacity-70', HUES[state])} />
      <div className={cn('absolute inset-[12%] rounded-full bg-gradient-to-br', HUES[state])} />
      <div className="absolute inset-[12%] rounded-full bg-[radial-gradient(circle_at_30%_25%,rgba(255,255,255,0.55),transparent_45%)]" />
    </motion.div>
  );
}
